import { createIcon } from '@chakra-ui/react';

export const HubspotMenuIcon = createIcon({
  displayName: 'HubspotMenuIcon',
  viewBox: '0 0 32 32',
  path: (
    <>
      <rect x='0' width='32' height='32' fill='#fe7959' />
      <g mask='url(#mask0_47_35903)'>
        <rect
          x='-2.4082'
          y='-4.64355'
          width='36.8172'
          height='41.2903'
          fill='url(#pattern0_hs)'
        />
      </g>
      <defs>
        <pattern
          id='pattern0_hs'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref='#image0_47_35903'
            transform='scale(0.0046729 0.00416667)'
          />
        </pattern>
        <image
          id='image0_47_35903'
          width='214'
          height='240'
          href='data:image/png;base64,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'
        />
      </defs>
    </>
  ),
});
